import { render, staticRenderFns } from "./hyzj.vue?vue&type=template&id=59b83ac6&scoped=true&"
import script from "./hyzj.vue?vue&type=script&lang=js&"
export * from "./hyzj.vue?vue&type=script&lang=js&"
import style0 from "./hyzj.vue?vue&type=style&index=0&id=59b83ac6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b83ac6",
  null
  
)

export default component.exports